
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import ShopHeaderRepository from '@/repositories/content/ShopHeaderRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class ShopHeaderFormScreen extends Vue {
    @Inject()
    private readonly shopHeaderRepository!: ShopHeaderRepository;
}
